import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// SaaSLogic SDK — must load before any component tries to render the
// <sl-new-subscription> widget. Loaded synchronously here so the global
// `Saaslogic` object is available by the time Angular bootstraps + any
// downstream component's ngAfterViewInit runs.
const saaslogicSdkUrl = environment.production
  ? 'https://cdn.saaslogic.io/js/v1/saaslogicsdk.js'
  : 'https://sl-sandbox-cdn.s3.us-east-2.amazonaws.com/sandbox/saaslogicsdk.sandbox.js';

function loadSaaslogicSdk(): Promise<void> {
  return new Promise<void>((resolve) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-saaslogic-sdk]');
    if (existing) {
      if ((window as unknown as { Saaslogic?: unknown }).Saaslogic) resolve();
      else existing.addEventListener('load', () => resolve(), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = saaslogicSdkUrl;
    script.async = false;
    script.dataset['saaslogicSdk'] = 'true';
    script.addEventListener('load', () => resolve(), { once: true });
    // Resolve on error too — components that need the SDK will surface a
    // clearer "widget failed to load" message themselves rather than the
    // whole app failing to bootstrap.
    script.addEventListener('error', () => resolve(), { once: true });
    document.head.appendChild(script);
  });
}

loadSaaslogicSdk().finally(() => {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
});
